module.exports = __webpack_public_path__ + "815f05b8fb514c2181af68bee096556b.svg";